<template>
  <div class="update-subscription-payment">
    <div class="buyer" v-if="subscription.buyer">
      <div class="update-details">
        <div class="message">
          <h2>{{ $t("message.reactivate-subscription") }}</h2>
          <p>
            {{
              subscription.discount_token
                ? $t("message.discount-expired", [subscription.discount_token])
                : $t("message.subscription-expired")
            }}.
            {{
              $t("message.reactivate-subscription-message", [
                currentEdition.name,
              ])
            }}
          </p>
          <i18n path="message.reactivate-subscription-contact" tag="p">
            <a href="currentEdition.helpdesk_location" target="_blank">{{
              $t("message.visit-help-center")
            }}</a>
          </i18n>
        </div>
        <select-plan
          :subscriptionId="subscription.id"
          :showLearners="false"
          :showPlansInModal="true"
          :showAnnualNudge="true"
          :hideDiscount="true"
          :hideNext="true"
        >
        </select-plan>

        <restart-or-edit-payment
          :subscription="subscription"
          displayAmountDue
          @done="done"
          v-if="subscription.last4"
        >
        </restart-or-edit-payment>
        <add-payment
          :subscription="subscription"
          displayAmountDue
          @done="done"
          v-else
        >
        </add-payment>
      </div>
    </div>
    <div class="learner" v-if="!subscription.buyer">
      <div class="message">
        <h2>{{ $t("message.subscription-inactive") }}</h2>
        <p>
          {{ $t("message.subscription-to-x-expired", [currentEdition.name]) }}
        </p>
        <i18n
          v-if="subscription.has_billing"
          path="message.subscription-expired-learner"
          tag="p"
        >
          <a href="currentEdition.helpdesk_location" target="_blank">{{
            $t("message.visit-help-center")
          }}</a>
        </i18n>
        <p v-else-if="subscription.is_admin">
          {{
            $t("message.invoiced-subscription-expired-admin", [
              currentEdition.name,
            ])
          }}
        </p>
        <p v-else>
          {{
            $t("message.invoiced-subscription-expired", [currentEdition.name])
          }}
        </p>
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
.update-subscription-payment {
  max-width: 600px;

  table {
    margin-bottom: 1em;
    padding-left: 12px;
    border-left: 3px solid #999;

    th {
      font-weight: bold;
      text-transform: uppercase;
      color: #666;
      font-size: 0.75em;
    }

    td {
      padding-right: 20px;
    }

    .failed {
      color: #a00;
      font-size: 0.9em;
      font-weight: bold;
    }
  }
  .plan-details {
    margin: 1em 0;
  }
  h2,
  strong {
    font-weight: bold;
  }
  h2 {
    margin-bottom: 1.5em;
  }
  .buyer .message {
    border-bottom: solid #ccc 1.5px;
  }
  .spinner::v-deep {
    height: 1.7em;
    width: 1.7em;
    vertical-align: middle;
    margin-left: 5px;
  }
  .payment-method {
    p {
      padding-bottom: 0px;
      a {
        color: #333;
        background: #ccc;
        border-radius: 999px;
        padding: 3px 9px 5px 9px;
        margin-left: 8px;
        position: relative;
      }
    }
    .edit {
      text-decoration: none;
      padding: 5px 18px;
      display: inline;
      width: fit-content;
    }
  }
  .feedback {
    margin-top: 1em;
    background: #cccccc75;
    padding: 0.75em;
    border-radius: 5px;
  }
}
.loading {
  margin-left: calc(50% - 35px);
}
.spinner /deep/.spin-element {
  border-top-color: #ccc;
}
</style>

<script>
import axios from "axios";
import swal from "sweetalert";
import { mapGetters, mapState } from "vuex";
import Spinner from "@/common/components/Spinner";
import RestartOrEditPayment from "@/settings/RestartOrEditPayment";
import AddPayment from "@/settings/AddPayment";
import SelectPlan from "@/signup/SelectPlan";

export default {
  components: { Spinner, RestartOrEditPayment, AddPayment, SelectPlan },
  computed: {
    subscription() {
      return this.currentUser.inactive_subscription;
    },
    ...mapGetters(["currentEdition", "currentUser"]),
  },
  async mounted() {
    this.$store.commit("setLicenceCount", this.subscription.seats);
    this.$store.commit("setPricingPeriod", "monthly");
    await this.getLearners();
  },
  data() {
    return {
      stripeOptions: null,
      editing: false,
      retrying: false,
      success: false,
      error: false,
    };
  },
  methods: {
    done() {
      this.$emit("dismiss");
    },
    async getLearners() {
      let response = await axios.get("/payment/subscriptions");
      let subscriptions = response.data;
      let learners = [];
      subscriptions.forEach((sub) => {
        if (sub.id === this.subscription.id) {
          learners = sub.learners;
        }
      });
      this.$store.commit("setLearners", learners);
    },
  },
};
</script>
